export function parseJwt(token: string | null) {
  if (!token) { return }
  const base64Url = token.split('.')[1]
  const base64 = base64Url.replace('-', '+').replace('_', '/')
  return JSON.parse(window.atob(base64))
}

export const handleLogError = (error: any) => {
  if (error.response) {
    console.log(error.response.data);
  } else if (error.request) {
    console.log(error.request);
  } else {
    console.log(error.message);
  }
}
export namespace Helpers {
	export const CC_REGEXP: RegExp = new RegExp('\\bcc=(\\d+)-(\\w+)-([01]+)');
}